import type { Exercise } from "../core/exercises";
import { setLabels } from "../core/templates";
import { entryExercise, updateWorkoutSet, type Workout } from "../core/workout";
import { t } from "./texts";

type Apply = (fn: (w: Workout, now: number) => Workout) => void;

/**
 * During the rest after a set the sensor counted (todo 8): its count with −1 and +1, so it can be corrected right
 * away (the row's reps field works too). The corrected reps become the recording's ground truth when the workout ends.
 * `inTimer`: inside the full-screen timer's interval rest, else a bar above the rest bar.
 */
export function SensorFix(props: { workout: Workout; exercises: Exercise[]; apply: Apply; inTimer?: boolean }) {
  const r = props.workout.rest;
  const x = r && props.workout.exercises.find((y) => y.key === r.exKey);
  const i = x?.sets.findIndex((s) => s.key === r?.setKey) ?? -1;
  const set = x?.sets[i];
  if (!x || !set?.sensor) return null;
  const reps = set.reps ?? 0;
  const change = (n: number) => props.apply((v) => updateWorkoutSet(v, x.key, set.key, { reps: n }, entryExercise(props.exercises, x)));
  return (
    <div className={props.inTimer ? "sensor-fix in-timer" : "sensor-fix"} role="group" aria-label={t.sensor.counted(setLabels(x.sets)[i], reps)}>
      <span className="what">{t.sensor.counted(setLabels(x.sets)[i], reps)}</span>
      <button className={props.inTimer ? "timer-btn" : "secondary"} aria-label={t.sensor.fixLess} disabled={reps === 0} onClick={() => change(reps - 1)}>−1</button>
      <button className={props.inTimer ? "timer-btn" : "secondary"} aria-label={t.sensor.fixMore} onClick={() => change(reps + 1)}>+1</button>
    </div>
  );
}
